import { useState } from 'react';
import Typography from '@hpi-sox/hpstellar-core/visId/Typography';
import './external-sign-in.less';
import { Modal, Link, Button } from '@hpi-sox/hpstellar-core/visId';

/**
 * @param {Object} props
 * @param {Object} props.title              title of the modal
 * @param {Object} props.msBlockTitle       sub title of the modal
 * @param {Object} props.msgBlockContent    content of the modal
 * @param {Object} props.ctaProps           cta props of the learn more, login and sign up
 * 
 */

export default function ExternalSignIn({ data }) {
   
    if (!data) {
        return null;
    }

    const [isOpen, setIsOpen] = useState(true);
    const { title, msgBlockTitle, msgBlockContent, ctaProps} = data;
    const {learnMoreCTAProps, btns} = ctaProps || {};

    return (
        <>
        <Modal
            modalClassName='external-sign-in'
            isOpen={isOpen}
            onClose={() => setIsOpen(false)}
            backdropClassName='external-sign-in-backdrop backdrop-remove'
            title={title}
        >
            <div className="external-sign-in-content">
                {msgBlockTitle && 
                    <Typography responsive variant="h5" weight={400} className="sub-title">
                        {msgBlockTitle}
                    </Typography>}
                {msgBlockContent && 
                    <Typography responsive tag="div" variant="body1" weight={400} className={`${(learnMoreCTAProps && btns.length == 2)? 'all-ctas' : ''} msg-content `}>
                        <span dangerouslySetInnerHTML={{__html: msgBlockContent}}/>
                    </Typography>}
                <div className="cta-container">
                    {learnMoreCTAProps && 
                        <Link
                            aria-label="aria-label"
                            href={learnMoreCTAProps?.link}
                            theme="accent"
                            target="_blank"
                            >
                            {learnMoreCTAProps?.label}
                        </Link>
                    }  
                    <div className="cta-btn">
                        {btns.map(btn => (
                            <Button className="btn" to={btn?.link} variation={btn?.variation}>
                                {btn?.label}
                            </Button>
                        ))}
                    </div>
                </div>
            </div>
        </Modal>
        </>
    );
}
